module.exports = __webpack_public_path__ + "assets/a9af58b9229510a0e09a1d4084290889.svg";